import { Badge } from '@/components/ui/badge';

import { TOOL_STATUS, TOOL_TYPE, type ToolStatus, type ToolType } from '@/types/tool.type';

export const renderToolStatusBadge = (status: ToolStatus) => {
  switch (status) {
    case TOOL_STATUS.Active:
      return (
        <Badge className="border-green-600/20 bg-green-50 text-green-700 dark:border-green-500/20 dark:bg-green-400/10 dark:text-green-400">
          Active
        </Badge>
      );
    case TOOL_STATUS.Inactive:
      return (
        <Badge className="border-slate-600/10 bg-slate-100 text-slate-700 dark:border-slate-500/20 dark:bg-slate-400/10 dark:text-slate-300">
          Inactive
        </Badge>
      );
    case TOOL_STATUS.Error:
      return (
        <Badge className="border-red-600/10 bg-red-50 text-red-700 dark:border-red-500/20 dark:bg-red-400/10 dark:text-red-400">
          Error
        </Badge>
      );
    default:
      return <Badge variant="secondary">{status}</Badge>;
  }
};

export const renderToolTypeBadge = (type: ToolType) => {
  switch (type) {
    case TOOL_TYPE.MCP:
      return (
        <Badge className="border-blue-200 bg-blue-50 text-blue-700 dark:border-blue-500/20 dark:bg-blue-500/10 dark:text-blue-300">
          MCP
        </Badge>
      );
    case TOOL_TYPE.Other:
      return (
        <Badge className="border-slate-600/10 bg-slate-100 text-slate-700 dark:border-slate-500/20 dark:bg-slate-400/10 dark:text-slate-300">
          Other
        </Badge>
      );
    default:
      return <Badge variant="secondary">{type}</Badge>;
  }
};
